import { useContext, useEffect } from "react";
import googleIcon from "../../src/images/google-icon.png";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-tippy/dist/tippy.css";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

import USFlag from "../../src/images/flags/uk-flag-icon.png";
import FranceFlag from "../../src/images/flags/french-flag-icon.png";
import RehappLogo from "../../src/images/logo_ticket_hub.png";
import { useAuth } from "../context/AuthContext";
import { showCustomToast } from "../misc/CustomToast";
import { LanguageContext } from "../context/LanguageContext";
import { useNavigate } from "react-router-dom";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebase";
import BGLogin from "../images/bgapp.png";
import { useTheme } from "@mui/material/styles";

export default function LoginDesktop() {
  const theme = useTheme();
  const { translate, language, setLanguage } = useContext(LanguageContext);
  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
  };
  const navigate = useNavigate();
  const { signInWithGoogle, currentUser } = useAuth();

  async function handleSignInWithGoogle() {
    try {
      const result = await signInWithGoogle();
      const email = result.user.email;

      const inviteQ = query(
        collection(db, "companies"),
        where("invitedEmails", "array-contains", email)
      );
      const inviteSnap = await getDocs(inviteQ);

      if (inviteSnap.empty) {
        showCustomToast(translate("SuccessfullyLoggedInWithGoogle"), "success");
      } else {
        showCustomToast(translate("SuccessfullyLoggedInWithGoogle"), "success");
      }
    } catch (error) {
      if (error.code === "permission-denied") {
        showCustomToast(translate("MustLogInWithGmailOrGsuite"), "error");
      } else {
        showCustomToast(
          translate("Failed to log in with your Google account"),
          "error"
        );
      }
    }
  }

  useEffect(() => {
    console.log("👀 Login.useEffect currentUser change:", currentUser);
    if (!currentUser) return;
    (async () => {
      const snap = await getDoc(doc(db, "profilsUsers", currentUser.uid));

      const data = snap.data() || {};
      if (data.companyId) {
        navigate("/app");
      } else {
        // nouvel utilisateur (pas encore rattaché à une company) -> ProfileForm
        navigate("/app/profile", { replace: true });
      }
    })();
  }, [currentUser, navigate]);

  return (
    <div
      className="sign-main-container"
      style={{
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.default,
      }}
    >
      <div className="sign-left-container">
        <img
          src={RehappLogo}
          alt="Rehapp Logo"
          style={{ height: "100px", width: "auto" }}
        />
        <div
          style={{
            height: "40%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <div className="signup-container-title" style={{ width: "100%" }}>
            <Box className="signup-title" sx={{ color: "text.primary" }}>
              {translate("WelcomeToTicketHub")}
            </Box>
          </div>

          <div className="container-google-sso" style={{ fontSize: "10px" }}>
            <Button
              sx={{
                borderRadius: "30px",
                paddingTop: "10px",
                paddingBottom: "10px",
                color: theme.palette.text.primary, // texte du bouton
                borderColor: theme.palette.divider, // bordure
                width: "100%",
                height: "auto",
                fontSize: "10px",
                "@media (max-width: 1100px)": {
                  width: "90%", // Lorsque la largeur de l'écran est inférieure à 500 pixels, la largeur sera de 70%
                  fontSize: "10px",
                },
              }}
              variant="outlined"
              onClick={handleSignInWithGoogle}
            >
              {" "}
              <img
                alt="Google icon"
                src={googleIcon}
                className="google-icon"
                width={"30px"}
              />
              <div
                style={{ fontSize: "14px", color: "inherit", paddingLeft: 20 }}
              >
                {translate("LogInWithGoogle")}
              </div>
            </Button>
          </div>

          <div
            style={{
              paddingLeft: "0px",
              paddingTop: "0px",
              height: "10%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <FormControl
              variant="outlined"
              size="small"
              sx={{
                minWidth: 180,
              }}
            >
              <InputLabel
                id="language-select-label"
                sx={{
                  color: "text.secondary",
                  "&.Mui-focused": { color: "primary.main" },
                }}
              >
                Language
              </InputLabel>

              <Select
                sx={{
                  bgcolor: "background.paper",
                  color: "text.primary",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "divider",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "divider",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "primary.main",
                  },
                  "& .MuiSvgIcon-root": { color: "text.primary" },
                }}
                labelId="language-select-label"
                id="language-select"
                value={language}
                onChange={handleLanguageChange}
                label="Language"
                renderValue={(selected) => (
                  // <Box display="flex" alignItems="center">
                  <Box
                    display="flex"
                    alignItems="center"
                    sx={{ color: "text.primary" }}
                  >
                    {selected === "en" && (
                      <img
                        src={USFlag}
                        alt="US Flag"
                        style={{ width: 20, marginRight: 10 }}
                      />
                    )}
                    {selected === "fr" && (
                      <img
                        src={FranceFlag}
                        alt="France Flag"
                        style={{ width: 20, marginRight: 10 }}
                      />
                    )}

                    {selected === "en"
                      ? "English"
                      : selected === "fr"
                      ? "Français"
                      : "ภาษาไทย"}
                  </Box>
                )}
              >
                <MenuItem value="en">
                  <Box display="flex" alignItems="center">
                    <img
                      src={USFlag}
                      alt="US Flag"
                      style={{ width: 20, marginRight: 10 }}
                    />
                    English
                  </Box>
                </MenuItem>
                <MenuItem value="fr">
                  <Box display="flex" alignItems="center">
                    <img
                      src={FranceFlag}
                      alt="France Flag"
                      style={{ width: 20, marginRight: 10 }}
                    />
                    Français
                  </Box>
                </MenuItem>
              </Select>
              <div
                style={{
                  textAlign: "center",
                  paddingTop: "50px",
                }}
              >
                <div
                  style={{
                    fontWeight: 600,
                    cursor: "pointer",
                    color: "inherit",
                  }}
                  onClick={() => navigate("/")}
                >
                  {translate("WhoAreWe")}
                </div>
              </div>
            </FormControl>
          </div>
        </div>
      </div>

      <div
        className="sign-right-container-2"
        style={{
          flex: 1,
          borderLeft: `1.5px solid ${theme.palette.divider}`,
          backgroundImage: `url(${BGLogin})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />

      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={theme.palette.mode === "dark" ? "dark" : "light"}
      />
    </div>
  );
}
